import type {
  ActivitiesConfigVersionFormat,
  InsuranceProduct,
  InsuranceProductVersion,
  ProductVersionFormat,
} from '../../model/model.ts'

import type { NlAovqlStaticFilesId } from './model.ts'
import type { NlAovqlPolicyItem, NlAovqlPolicyItemsState } from './nl-aovql-insurance.ts'
import type { NlAovqlPricingVersion } from './nl-aovql-pricing-versions.ts'
import { nlAovqlPolicyItemsV1_0_0 } from './v1_0_0/policy-items.ts'
import { nlAovql_V1_0_0_StaticFilesIds } from './v1_0_0/static-files.ts'

export const nlAovqlProductName = 'product-nl-aov-quantum-leben'
export type NlAovqlProductName = typeof nlAovqlProductName

type NlAovqlProductVersionFormat = ProductVersionFormat<'nl-aov-quantum-leben'>
type NlAovqlActivitiesConfigVersionFormat = ActivitiesConfigVersionFormat<NlAovqlProductName>

export const nlAovqlProductVersions = [
  /**
   * Initial version
   */
  'product-nl-aov-quantum-leben-1.0.0-2026-08-13',
] as const satisfies NlAovqlProductVersionFormat[]

export type NlAovqlProductVersion = (typeof nlAovqlProductVersions)[number]

export const nlAovqlRiskCarrierProductTypeNames = ['nl-aovql-inde-v1'] as const

export type NlAovqlRiskCarrierProductType = (typeof nlAovqlRiskCarrierProductTypeNames)[number]

export const nlAovqlProduct_V_1_0_0 = {
  version: 'product-nl-aov-quantum-leben-1.0.0-2026-08-13',
  description: 'Version initiale du produit NL AOV Quantum Leben',
  policyItems: nlAovqlPolicyItemsV1_0_0,
  staticFilesId: [...nlAovql_V1_0_0_StaticFilesIds],
  pricingVersion: ['pricing-nl-aov-quantum-leben-1.0.0-2026-08-13'],
  activitiesConfigVersion: 'activities-config-product-nl-aov-quantum-leben-1.0.0-2026-08-13',
} as const satisfies InsuranceProductVersion<
  NlAovqlProductName,
  NlAovqlProductName,
  NlAovqlProductVersion,
  NlAovqlPolicyItem,
  NlAovqlStaticFilesId,
  NlAovqlPricingVersion,
  NlAovqlActivitiesConfigVersionFormat,
  NlAovqlPolicyItemsState
>

export const nlAovqlProduct = {
  id: 'nl-aovql',
  versions: {
    'product-nl-aov-quantum-leben-1.0.0-2026-08-13': nlAovqlProduct_V_1_0_0,
  },
} as const satisfies InsuranceProduct<
  NlAovqlProductName,
  NlAovqlProductName,
  NlAovqlProductVersion,
  NlAovqlPolicyItem,
  NlAovqlStaticFilesId,
  NlAovqlPricingVersion,
  NlAovqlActivitiesConfigVersionFormat,
  NlAovqlPolicyItemsState
>

export type NlAovqlProduct = typeof nlAovqlProduct
